import {_} from 'lodash';
import * as ko from "knockout";
import {ITableDef} from "./index";
import {KOSubscriptionTracker} from "../../util/KOSubscriptionTracker";
import {TableBasic} from "./basic";
import {lm} from "../../appContext";
import {ISplitButtonParams} from "@component/button/splitButton/split-button";
import selectedHtml from './selected.html?raw';

export const template = selectedHtml

export class Selected<T> {

    private readonly kosub: KOSubscriptionTracker = new KOSubscriptionTracker()
    private readonly allCheckbox: KnockoutObservable<boolean> = ko.observable(true)
    private readonly tableDef: ITableDef<T>;
    private readonly tableBasic: TableBasic<T>;
    private readonly operationsButton: ISplitButtonParams | undefined;

    constructor(private def: ITableDef<T>) {
        this.tableDef = _.clone(def)
        delete this.tableDef.searchkey
        this.tableDef.rows = _.clone(def.rows ?? {})
        if (this.tableDef.rows) {
            this.tableDef.rows.getTitle = () => lm.t(`remove s|s:((${this.tableDef.translationKey}|ac))`) ?? ''
            this.tableDef.rows.onClick = o => {this.tableDef.selected?.remove(o)}
        }
        this.tableDef.translationKey = this.tableDef.translationKey ?? 'object'
        this.tableDef.navigation = false
        this.tableDef.data = this.tableDef.selected ?? ko.observableArray<T>([])
        this.tableBasic = new TableBasic(this.tableDef)

        if (def.operationsButton) {
            const operationsButton = _.clone(def.operationsButton)
            if (!Array.isArray(operationsButton.mainButton)) {
                operationsButton.mainButton = [operationsButton.mainButton]
                operationsButton.mainButton.unshift({
                    label: 'Clear selection',
                    onClick: () => {
                        this.onRemoveAllSelectedClick()
                    }
                })
            }
            this.operationsButton = operationsButton
        }
    }

    private onRemoveAllSelectedClick() {
        this.tableDef.selected?.removeAll()
    }

    private getSelectedLabel() {
        let numSelected = this.tableDef.selected?.().length ?? 0;
        return lm.t(`${numSelected} ((${this.tableDef.translationKey}|ac|n:${numSelected}))`) ?? ''
    }

    dispose() {
        this.kosub.unsuscribeAll()
    }

}
